<template>
  <div>
    <portlet
            :actionsBlock="true"
            :icon="'fad fa-boxes'"
            :title="$t('products.createProduct')"
    >
      <template slot="actionsBlock">
        <back-button :link="'products'"/>
      </template>
      <template slot="portletBody">
        <div class="row">
          <div class="form-group col">
            <label for="product-name">{{$t('products.name')}}</label>
            <input class="form-control"
                   id="product-name"
                   name="product-name"
                   type="text"
                   v-model="product.name"
                   v-validate="'required'">
          </div>
        </div>
      </template>
    </portlet>

    <div class="row">
      <div class="col product-properties">
        <portlet
                :icon="'fad fa-list'"
                :title="$t('products.properties.title')"
        >
          <template slot="portletBody">
            <product-properties
                    :product="product"
                    @addedRow="copyProduct">
              >
            </product-properties>
          </template>
        </portlet>
      </div>
      <div class="col product-workflows">
        <portlet
                :icon="'fad fa-project-diagram'"
                :title="$t('products.workflows.title')"
        >
          <template slot="portletBody">
            <product-workflows
                    :product="product"
                    @addedRow="copyProduct">
              >
            </product-workflows>
          </template>
        </portlet>
      </div>
    </div>

    <div class="col-12 text-right bg-white m-box-shadow pr-5 pl-5 pt-4 pb-4">
      <router-link :to="{name:'products'}" class="btn btn-cancel">
        {{$t('ui.cancel')}}
      </router-link>
      <button @click="createProduct()" class="btn btn-primary ml-3" type="button">
        {{$t('ui.create')}}
      </button>
    </div>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import ProductProperties from '../../components/product/ProductProperties';
  import ProductWorkflows from '../../components/product/ProductWorkflows';
  import {productPrevent} from '../../mixins/product/productPrevent';

  //@vuese
  //@group Products
  // This component allows product creation
  export default {
    name: 'CreateProduct',
    components: {ProductProperties, ProductWorkflows},
    props: {
      // @vuese
      //  Deprecated or never used ? (CHECK)
      id:{
        required:true,
        type:Number,

      }
    },
    mixins: [productPrevent],
    data() {
      return {
        product: {
          name: '',
          properties: [],
          workflows: []
        }
      };
    },
    computed: {
      ...mapGetters(['getAPICompanyID', 'getUserData'])
    },
    methods: {
      /**
       * @vuese
       * Validates and saves product data to Firebase
       */
      createProduct() {
        this.$validator.validateAll().then((result) => {
          let validationArrayChild = this.$children.map(function (child) {
            return child.$validator.validateAll();
          });
          Promise.all(validationArrayChild).then((v) => {
            let validCheck = _.includes(v, false);
            if(result && !validCheck) {
              this.product.companyId = this.getAPICompanyID;
              this.product.createdBy = this.getUserData;
              this.properties = _.reject(this.properties, ['name', null]);
              this.workflows = _.reject(this.workflows, ['workflowName', null]);

              this.$store.dispatch('products/set', this.product).then(() => {
                this.disableNavigation = false;
                this.$router.push({name: 'products'});
                this.swalToastSuccess(this.$t('products.created'));

              }).catch(() => {
                this.$toasted.global.failedRequest();
              });
            } else {
              this.$toasted.global.failedFormRequest();
            }
          });
        });
      },
      /**
       * @vuese
       * keeps track of changes to the product data
       */
      copyProduct() {
        this.productCopy = JSON.parse(JSON.stringify(this.product));
      }
    }
  };
</script>
